var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-videojs"},[_c('video',{staticClass:"video-js",attrs:{"id":"videoPlayer","crossOrigin":"anonymous","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }